// Curated list of countries with ISO alpha-2 code, dial code and flag emoji.
// Used by the popup form's country dial-code selector.
export const COUNTRIES = [
  { code: "US", name: "United States", dial: 1, flag: "🇺🇸" },
  { code: "CA", name: "Canada", dial: 1, flag: "🇨🇦" },
  { code: "GB", name: "United Kingdom", dial: 44, flag: "🇬🇧" },
  { code: "AU", name: "Australia", dial: 61, flag: "🇦🇺" },
  { code: "PK", name: "Pakistan", dial: 92, flag: "🇵🇰" },
  { code: "IN", name: "India", dial: 91, flag: "🇮🇳" },
  { code: "AE", name: "United Arab Emirates", dial: 971, flag: "🇦🇪" },
  { code: "SA", name: "Saudi Arabia", dial: 966, flag: "🇸🇦" },
  { code: "DE", name: "Germany", dial: 49, flag: "🇩🇪" },
  { code: "FR", name: "France", dial: 33, flag: "🇫🇷" },
  { code: "IT", name: "Italy", dial: 39, flag: "🇮🇹" },
  { code: "ES", name: "Spain", dial: 34, flag: "🇪🇸" },
  { code: "NL", name: "Netherlands", dial: 31, flag: "🇳🇱" },
  { code: "BE", name: "Belgium", dial: 32, flag: "🇧🇪" },
  { code: "CH", name: "Switzerland", dial: 41, flag: "🇨🇭" },
  { code: "SE", name: "Sweden", dial: 46, flag: "🇸🇪" },
  { code: "NO", name: "Norway", dial: 47, flag: "🇳🇴" },
  { code: "DK", name: "Denmark", dial: 45, flag: "🇩🇰" },
  { code: "FI", name: "Finland", dial: 358, flag: "🇫🇮" },
  { code: "IE", name: "Ireland", dial: 353, flag: "🇮🇪" },
  { code: "PT", name: "Portugal", dial: 351, flag: "🇵🇹" },
  { code: "PL", name: "Poland", dial: 48, flag: "🇵🇱" },
  { code: "CZ", name: "Czech Republic", dial: 420, flag: "🇨🇿" },
  { code: "GR", name: "Greece", dial: 30, flag: "🇬🇷" },
  { code: "TR", name: "Turkey", dial: 90, flag: "🇹🇷" },
  { code: "RU", name: "Russia", dial: 7, flag: "🇷🇺" },
  { code: "UA", name: "Ukraine", dial: 380, flag: "🇺🇦" },
  { code: "IL", name: "Israel", dial: 972, flag: "🇮🇱" },
  { code: "EG", name: "Egypt", dial: 20, flag: "🇪🇬" },
  { code: "ZA", name: "South Africa", dial: 27, flag: "🇿🇦" },
  { code: "NG", name: "Nigeria", dial: 234, flag: "🇳🇬" },
  { code: "KE", name: "Kenya", dial: 254, flag: "🇰🇪" },
  { code: "MA", name: "Morocco", dial: 212, flag: "🇲🇦" },
  { code: "BR", name: "Brazil", dial: 55, flag: "🇧🇷" },
  { code: "MX", name: "Mexico", dial: 52, flag: "🇲🇽" },
  { code: "AR", name: "Argentina", dial: 54, flag: "🇦🇷" },
  { code: "CL", name: "Chile", dial: 56, flag: "🇨🇱" },
  { code: "CO", name: "Colombia", dial: 57, flag: "🇨🇴" },
  { code: "PE", name: "Peru", dial: 51, flag: "🇵🇪" },
  { code: "CN", name: "China", dial: 86, flag: "🇨🇳" },
  { code: "JP", name: "Japan", dial: 81, flag: "🇯🇵" },
  { code: "KR", name: "South Korea", dial: 82, flag: "🇰🇷" },
  { code: "SG", name: "Singapore", dial: 65, flag: "🇸🇬" },
  { code: "MY", name: "Malaysia", dial: 60, flag: "🇲🇾" },
  { code: "ID", name: "Indonesia", dial: 62, flag: "🇮🇩" },
  { code: "TH", name: "Thailand", dial: 66, flag: "🇹🇭" },
  { code: "PH", name: "Philippines", dial: 63, flag: "🇵🇭" },
  { code: "VN", name: "Vietnam", dial: 84, flag: "🇻🇳" },
  { code: "BD", name: "Bangladesh", dial: 880, flag: "🇧🇩" },
  { code: "LK", name: "Sri Lanka", dial: 94, flag: "🇱🇰" },
  { code: "NP", name: "Nepal", dial: 977, flag: "🇳🇵" },
  { code: "QA", name: "Qatar", dial: 974, flag: "🇶🇦" },
  { code: "KW", name: "Kuwait", dial: 965, flag: "🇰🇼" },
  { code: "BH", name: "Bahrain", dial: 973, flag: "🇧🇭" },
  { code: "OM", name: "Oman", dial: 968, flag: "🇴🇲" },
  { code: "JO", name: "Jordan", dial: 962, flag: "🇯🇴" },
  { code: "LB", name: "Lebanon", dial: 961, flag: "🇱🇧" },
  { code: "NZ", name: "New Zealand", dial: 64, flag: "🇳🇿" },
];

export function findCountryByCode(code) {
  if (!code) return null;
  const c = String(code).toUpperCase();
  return COUNTRIES.find((x) => x.code === c) || null;
}

export const DEFAULT_COUNTRY = COUNTRIES.find((c) => c.code === "US");
